(() => {
  const STORAGE_KEY = 'black_natasha_cookie_consent';
  const banner = document.querySelector('[data-bn-consent]');
  const dialog = document.querySelector('[data-bn-consent-dialog]');
  if (!banner || !dialog) return;

  const version = banner.dataset.consentVersion;
  const analytics = dialog.querySelector('[data-consent-analytics]');
  const marketing = dialog.querySelector('[data-consent-marketing]');
  const preferences = dialog.querySelector('[data-consent-preferences]');
  let privacyApi;

  const readStoredConsent = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return value?.version === version ? value : null;
    } catch (_error) {
      return null;
    }
  };

  const persist = (consent) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...consent, version, timestamp: new Date().toISOString() }));
    } catch (_error) {
      // Shopify still stores the consent decision if local storage is unavailable.
    }
  };

  const applyConsent = (consent) => {
    const finish = () => {
      persist(consent);
      banner.hidden = true;
      if (dialog.open) dialog.close();
      document.dispatchEvent(new CustomEvent('bn:consent-updated', { detail: consent }));
    };

    if (!privacyApi) {
      finish();
      return;
    }

    privacyApi.setTrackingConsent(
      {
        analytics: consent.analytics,
        marketing: consent.marketing,
        preferences: consent.preferences,
      },
      finish
    );
  };

  const openSettings = () => {
    const stored = readStoredConsent();
    const current = privacyApi?.currentVisitorConsent?.() || {};
    analytics.checked = stored?.analytics ?? current.analytics === 'yes';
    marketing.checked = stored?.marketing ?? current.marketing === 'yes';
    preferences.checked = stored?.preferences ?? current.preferences === 'yes';
    dialog.showModal();
  };

  banner.querySelector('[data-consent-accept]').addEventListener('click', () => {
    applyConsent({ analytics: true, marketing: true, preferences: true });
  });
  banner.querySelector('[data-consent-reject]').addEventListener('click', () => {
    applyConsent({ analytics: false, marketing: false, preferences: false });
  });
  banner.querySelector('[data-consent-settings]').addEventListener('click', openSettings);
  dialog.querySelector('[data-consent-save]').addEventListener('click', () => {
    applyConsent({
      analytics: analytics.checked,
      marketing: marketing.checked,
      preferences: preferences.checked,
    });
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-open-cookie-settings]');
    if (!trigger) return;
    event.preventDefault();
    openSettings();
  });

  const initialize = () => {
    privacyApi = window.Shopify?.customerPrivacy;
    banner.hidden = Boolean(readStoredConsent());
  };

  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => initialize());
  } else {
    initialize();
  }
})();
